// extracted by mini-css-extract-plugin
module.exports = {"Ecosystem":"Ecosystem_Ecosystem__u1n2f"};